/* Souperstar: checkout from the cart drawer (or anywhere the order planner isn't shown).
   Always goes to the cart page first so the customer confirms delivery/pickup, date and time in the order planner. */
(function () {
  if (window.__sspGuard) return; window.__sspGuard = true;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  document.addEventListener('click', function (e) {
    var c = e.target.closest && e.target.closest('[name="checkout"], a[href*="/checkout"]');
    if (!c) return;
    if (document.querySelector('[data-ssp-root]')) {
      /* On the cart page: send drawer/other checkout buttons through the cart page's own Check out button,
         which sets Ship/Pickup and the delivery address before opening checkout. */
      var pb = document.querySelector('#CartPageForm [name="checkout"]');
      if (!pb || c === pb || c.closest('#CartPageForm')) return;
      e.preventDefault(); e.stopPropagation();
      var cl = document.querySelector('.drawer--is-open .js-drawer-close, .drawer--is-open [data-drawer-close]'); if (cl) cl.click();
      setTimeout(function () { pb.scrollIntoView({ block: 'center' }); pb.click(); }, 350);
      return;
    }
    e.preventDefault(); e.stopPropagation();
    fetch(root + 'cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      var a = cart.attributes || {};
      window.location.href = (a['Delivery Method'] && a['Delivery Date (YYYY-MM-DD)'] && a['Delivery Time']) ? root + 'cart' : root + 'cart?ssp=1';
    }).catch(function () { window.location.href = root + 'cart?ssp=1'; });
  }, true);
})();
/* On the cart page after being sent from the drawer (?ssp=1): explain why */
document.addEventListener('DOMContentLoaded', function () {
  if (!/[?&]ssp=1/.test(location.search)) return;
  var n = 0, t = setInterval(function () {
    var err = document.querySelector('[data-ssp-err]'), r = document.querySelector('[data-ssp-root]');
    if (err && r) {
      clearInterval(t);
      err.textContent = 'Please choose delivery or self collection, a date and a time, then check out.';
      err.hidden = false;
      r.scrollIntoView({ block: 'center' });
    } else if (++n > 50) clearInterval(t);
  }, 100);
});
